export default __webpack_public_path__ + "static/O0292-66541b70fd94ffd260014e8014e2b413.png";